// A camera-capture tile of the kiosk (kiosk-details.html, kiosk-medical-aid.html `.photo`): the tablet's camera through a file
// input with `capture`, the photo compressed on the device (capture.ts) and shown with the "captured 08:19" caption and Retake.
import { useRef, useState } from "react";
import { formatTime } from "../lib/format";
import { compressImage, type Capture } from "./capture";

const CameraIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 7h3l1.5-2h5L14 7h3v9H3z" /><circle cx="10" cy="11.5" r="2.5" /></svg>
);

export function PhotoTile({ label, value, onCapture, facing = "environment" }: { label: string; value: Capture | null; onCapture: (c: Capture) => void; facing?: "environment" | "user" | undefined }) {
  const input = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const onFile = async (file: File | undefined) => {
    if (!file) return;
    setBusy(true);
    setError(null);
    try { onCapture(await compressImage(file)); }
    catch (err) { setError(err instanceof Error ? err.message : "The photo could not be used."); }
    finally { setBusy(false); if (input.current) input.current.value = ""; }
  };
  return (
    <div className="field">
      <label>{label}</label>
      <div className="photo">
        {value ? <img src={value.previewUrl} alt={`${label}, captured`} width={320} height={240} /> : <CameraIcon />}
        {value && <span className="cap">captured {formatTime(value.capturedAt)}</span>}
      </div>
      <input ref={input} type="file" accept="image/*" capture={facing} hidden aria-hidden="true" tabIndex={-1} onChange={(e) => void onFile(e.target.files?.[0])} />
      <button type="button" className="btn" disabled={busy} onClick={() => input.current?.click()}><CameraIcon />{busy ? "Processing…" : value ? "Retake" : "Take photo"}</button>
      {error && <div className="error" role="alert">{error}</div>}
    </div>
  );
}
